var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-white md:px-10 md:pt-10 md:pb-20 mt-12 px-8 pt-8 pb-16 min-h-screen",attrs:{"id":"app"}},[_c('Navigation'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }